module.exports = __webpack_public_path__ + "img/daka.c655bc2f.jpg";